import { ENVIRONMENT } from './Environment';

/**
 * Per-environment base URLs for one platform family (client or server).
 *
 * Structurally identical to `Record<Environment, string>` from `@cx-sdk/types`, but
 * declared from `ENVIRONMENT` directly: `@cx-sdk/types` depends on this package, so
 * importing it here would create a cycle.
 */
type EnvironmentUrlMap = Record<keyof typeof ENVIRONMENT, string>;

/**
 * MyOC platform API URLs for client platforms.
 *
 * Shared by `@cx-sdk/myoc` and `@cx-sdk/subs` — both talk to the same host, and the
 * two packages previously carried byte-identical private copies of these maps.
 */
export const MYOC_API_URL_CLIENT: EnvironmentUrlMap = {
  [ENVIRONMENT.LOCALHOST]: 'https://api.stg.occloud.io',
  [ENVIRONMENT.PROD]: 'https://api.oddschecker.com',
  [ENVIRONMENT.STG]: 'https://api.stg.occloud.io',
} as const;

/**
 * MyOC platform API URLs for server platforms (e.g. Node.js) that can use ILBs.
 *
 * Identical to the client map today; kept as a separate export so pointing server-side
 * traffic at an ILB stays a one-line change.
 */
export const MYOC_API_URL_SERVER: EnvironmentUrlMap = {
  [ENVIRONMENT.LOCALHOST]: 'https://api.stg.occloud.io',
  [ENVIRONMENT.PROD]: 'https://api.oddschecker.com',
  [ENVIRONMENT.STG]: 'https://api.stg.occloud.io',
} as const;
